<template>
	<div :id="idMap" class="divMap" :style="{ height: heightMap }"></div>
</template>

<script>
import icon from '@/assets/icon.png';

export default {
	name: 'GeofencePerson',
	props: {
		idMap: {
			type: String,
			required: true,
		},
		place: {
			type: Object,
			required: true,
		},
		heightMap: {
			type: String,
			default: '200px',
		},
		lat: {
			type: Number,
			default: 0,
		},
		lon: {
			type: Number,
			default: 0,
		},
		setLocationFlag: {
			type: Function,
			required: true,
		},
	},
	data() {
		return {
			infowindow: null,
			menu: false,
			persons: [],
			markers: [],
			overlay: false,
			map: null,
			allEvents: [],
			polygons: [],
			poly: null,
			centerPoligon: null,
			formattedAddress: '',
			defaultCenter: { lat: -33.4533107, lng: -70.6633059 },
		};
	},
	watch: {
		place() {
			this.initMap().then(() => this.setPersonMarker());
		},
		polygons(newValue) {
			if (newValue.length) {
				// eslint-disable-next-line no-undef
				this.poly = new google.maps.Polygon({
					paths: this.polygons,
					strokeColor: '#FF0000',
					strokeOpacity: 0.8,
					strokeWeight: 2,
					fillColor: '#FF0000',
					fillOpacity: 0.35,
				});
				this.poly.setMap(this.map);
				// eslint-disable-next-line no-undef
				const bounds = new google.maps.LatLngBounds();
				for (const poly of this.polygons) {
					// eslint-disable-next-line no-undef
					bounds.extend(new google.maps.LatLng(poly.lat, poly.lng));
				}

				// eslint-disable-next-line no-undef
				this.centerPoligon = new google.maps.Marker({
					position: {
						lat: bounds.getCenter().lat(),
						lng: bounds.getCenter().lng(),
					},
					title: this.place.name,
					icon,
					// eslint-disable-next-line no-undef
					animation: google.maps.Animation.DROP,
				});
				this.centerPoligon.setMap(this.map);
				// eslint-disable-next-line no-undef
				this.map.setCenter({
					lat: bounds.getCenter().lat(),
					lng: bounds.getCenter().lng(),
				});
				this.map.setZoom(18);
			} else {
				this.map.setCenter(this.defaultCenter);
				this.map.setZoom(8);
			}
		},
	},
	mounted() {
		this.initMap()
			.then(() => this.setPersonMarker())
			.then(() => this.setFlag());
	},
	methods: {
		async initMap() {
			// eslint-disable-next-line no-undef
			this.map = new google.maps.Map(document.getElementById(this.idMap), {
				zoom: 8,
				center: this.defaultCenter,
				streetViewControl: false,
				scaleControl: false,
				fullscreenControl: false,
				scrollwheel: true,
			});

			if (this.place.geofence) this.polygons = this.place.geofence;
		},
		setFlag() {
			// eslint-disable-next-line no-undef
			const coordinate = new google.maps.LatLng(this.lat, this.lon);
			// eslint-disable-next-line no-undef
			this.setLocationFlag(google.maps.geometry.poly.containsLocation(coordinate, this.poly));
		},
		setPersonMarker() {
			if (this.lat && this.lon) {
				const marker =
					// eslint-disable-next-line no-undef
					new google.maps.Marker({
						position: {
							lat: this.lat,
							lng: this.lon,
						},
						map: this.map,
					});
				marker.setMap(this.map);
			}
		},
	},
};
</script>

<style scoped>
.divMap {
	background-color: white;
	width: 100%;
	border: 1px solid gray;
	margin-top: 10px;
}
</style>
